import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { renderRoutes } from 'react-router-config';
import './App.css';
import routes from './routes';
import { AuthContextProvider } from './context/Auth';
import ErrorBoundary from './ErrorBoundary';

const history = createBrowserHistory();

function App () {

  return (
    <>

      <AuthContextProvider>
        <Router history={history}>
          <ErrorBoundary>
            {renderRoutes(routes)}
          </ErrorBoundary>
        </Router>
      </AuthContextProvider>

    </>
  );
};

export default App;